import { Component } from 'react';
import { connect, PromiseState } from 'react-refetch';
import Helmet from 'react-helmet';

import { api, titles } from '../data';

import LoadingAnimation from './modules/LoadingAnimation';
import NotFound from './NotFound';
import Title from './modules/Title';

class Post extends Component {
  render() {
    const post = this.props.post;
    return (
      <div>
        <Helmet title={post.title.rendered} titleTemplate={titles.titleTemplate} />
        <section className="single">
          <Title header="h1" title="お知らせ" />
          <article className="single__article">
            <div className="article__meta">
              <h2 className="article__meta__title"><span>{post.title.rendered}</span></h2>
              <time className="article__meta__date">{post.modified.split('T')[0].replace(/-/g, ' / ')}</time>
            </div>
            <div className="article__content">
              {post.featured_image
                ?
                  <figure className="article__content__img" style={{'backgroundImage': `url(${post.featured_image})`}} />
                : ''
              }
              <div className="article__content__desc" dangerouslySetInnerHTML={{__html: post.content.rendered}} />
            </div>
          </article>
        </section>
      </div>
    )
  }
}

class SingleFetch extends Component {
  render() {

    const { postFetch } = this.props;

    const allFetches = PromiseState.all([postFetch])

    // Pending
    if (allFetches.pending) {

      return <LoadingAnimation />

    // Error
    } else if (allFetches.rejected) {

      return <div>Error</div>

    // Complete without Error
    } else if (allFetches.fulfilled) {

      let [post] = allFetches.value;
      post = post[0];

      return (
        <div>
          { post
            ? <Post post={post} />
            : <NotFound />
          }
        </div>
      )
    }
  }
}

export default connect(props => ({
  postFetch: `${api.base_url}/posts?filter[name]=${props.params.news}`
}))(SingleFetch);



/** WEBPACK FOOTER **
 ** ./src/components/Single.js
 **/